import { render, staticRenderFns } from "./ApproveMissionProposal.vue?vue&type=template&id=3856dc92&"
import script from "./ApproveMissionProposal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ApproveMissionProposal.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports